export const all_routes = {
  // dashboard routes
  Home: "/",
  Work: "/work",
  Resources: "/resource",
  Contactus: "/contactus",
  OurStory: "/about/our-story",
  Careers: "/about/careers",
  LifeAtAlphai: "/about/life-at-alphai",
  EngagementModels: "/about/engagement-models",
  StartUps: "/who-we-serve/startups",
  Scaleups: "/who-we-serve/scale-ups",
  Enterprises: "/who-we-serve/enterprises",
  ITFirms: "/who-we-serve/it-firms",
  BankingFinance: "/industries/banking-finance",
  FoodBeverages: "/industries/food-beverages",
  RetailCommerce: "/industries/retail-commerce",
  Education: "/industries/education",
  Healthcare: "/industries/healthcare",
  Sports: "/industries/sports",
  SocialNetworking: "/industries/social-networking",
  SupplyChain: "/industries/supply-chain-logistics",
  TravelHospitality: "/industries/travel-hospitality",
  ProductEngineering: "/services/product-engineering/",
  Discovery: "/services/product-engineering/discovery",
  UXUIDesign: "/services/product-engineering/ux-ui",
  ChatGPTIntegration: "/services/product-engineering/chatgpt-integration",
  DigitalTransformation: "/services/product-engineering/digital-transformation",
  ProductDevelopment: "/services/product-engineering/product-development",
  Web: "/services/website-development/",
  Angular: "/services/website-development/angular",
  Reactjs: "/services/website-development/react",
  Vue: "/services/website-development/vue",
  Node: "/services/website-development/node",
  Python: "/services/website-development/python",
  Java: "/services/website-development/java",
  DotNet: "/services/website-development/dotnet",
  Bootstrap: "/capabilities/frontend/bootstrap",
  JavaScript: "/capabilities/frontend/javascript",
  HtmlCss: "/capabilities/frontend/html-css",
  Gatsby: "/capabilities/frontend/gatsbyjs",
  FontEnd: "/frontend-development/",
  BackEnd: "/backend-development/",
  MobileDevelopment: "/services/mobile-app-development/",
  AndroidAppDev: "/services/mobile-app-development/android",
  Flutter: "/services/mobile-app-development/flutter",
  IOSApp: "/services/mobile-app-development/ios",
  ReactNative: "/services/mobile-app-development/react-native",
  QAManagement: "/services/quality-assurance-management/",
  QualityAssurance: "/services/quality-assurance",
  ProductManagement: "/services/product-management",
  AppSupport: "/services/app-support-maintenance",
  AppModernization: "/services/app-modernization",
  ProjectManagement: "/services/project-management",
  TalentSolution: "/talent-solution/",
  BuildYourTeam: "/talent-solution/our-team",
  HireDeveloper: "/talent-solution/hire-developer",
  AIIntegration: "/capabilities/trending/ai-integration",
  BigData: "/capabilities/trending/big-data",
  Blockchain: "/capabilities/trending/blockchain",
  DevOps: "/services/devops",
  CICD: "/services/devops-ci-cd",
  CloudEng: "/services/devops-cloud",
  Consulting: "/services/devops-consulting",
  DigitalMarketing: "/digital-marketing/",
  ContentMarketing: "/digital-marketing/content",
  EmailMarketing: "/digital-marketing/email",
  Sco: "/digital-marketing/seo",
  BrandActivation: "/brand-activation/",
  BrandStrategy: "/brand-strategy",
  Digitalcampaigns: "/digital-campaigns",
  Influencercollaboration: "/influencer-collaboration",
  Develop: "/development/",
  MobileAppDevelopment: "/mobile-apps-development",
  WebsiteDevelopment: "/website-development",
  Design: "/design/",
  Animations: "/design/animations",
  GraphicDesign: "/design/graphic",
  WebDesign: "/design/web",
  UiuxDesign: "/design/ui-ux",
  Aws: "/capabilities/cloud/aws",
  Azure: "/capabilities/cloud/azure",
  GCP: "/capabilities/cloud/gcp",
  Cloud: "/cloud-services/",
  WordPress: "/capabilities/cms/wordpress",
  JAMStack: "/capabilities/cms/jamstack",
  WooCommerce: "/capabilities/cms/woocommerce",
  Cms: "/cms-development/",
  Database: "/database-development",
  FIreStore: "/capabilities/database/firestore",
  MongoDB: "/capabilities/database/mongodb",
  MySQL: "/capabilities/database/mysql",
  PostgreSQL: "/capabilities/database/postgresql",
  SQLServer: "/capabilities/database/sql-server"
};
